import { LeadDashboard } from '~/models/LeadDashboard'
import { LeadDashboardRepository } from './repository'

export class LeadDashboardService {
	static async getDashboard(leadId: string): Promise<LeadDashboard> {
		return await LeadDashboardRepository.getDashboard(leadId)
	}
}
